import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI207_3 = ({ hide }) => {
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  const questionData = [
    {
      fieldName: "taxAuthoritiesEngagement",
      title:
        "i. Describe the organization's approach to engagement with tax authorities, including any participation in cooperative compliance agreements or seeking advance pricing agreements.",
      type: "text",
      placeholder: "Enter Text",
      letter: "i.",
    },
    {
      fieldName: "taxPublicPolicyAdvocacy",
      title:
        "ii. Explain the organization's approach to public policy advocacy on tax, including any lobbying activities, stance on significant tax issues, and involvement with representative associations or committees engaged in tax-related public policy advocacy.",
      type: "text",
      placeholder: "Enter Text",
      letter: "ii.",
    },
    {
      fieldName: "stakeholderFeedback",
      title:
        "iii. Outline the processes for collecting and considering the views and concerns of stakeholders, including external stakeholders, and provide examples of how stakeholder feedback has influenced the organization's approach to tax, tax strategy, or tax practices.",
      type: "text",
      placeholder: "Enter Text",
      letter: "iii.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.stackeHoder;
      if (
        res?.data?.data?.year ? res?.data?.data?.year < currentYear - 1 : false
      )
        setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data)
      setFormData({
        taxAuthoritiesEngagement: data?.taxAuthoritiesEngagement || "",
        taxPublicPolicyAdvocacy: data?.taxPublicPolicyAdvocacy || "",
        stakeholderFeedback: data?.stakeholderFeedback || "",
      });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        stackeHoder: formData,
        type: "GRI200",
        submitted207_3: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/207-4/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/207-4/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      {!hide && <p className={styles.section_heading}>207 : Tax 2019</p>}
      <p className={styles.main_heading}>
        207-3 : Stakeholder engagement and management of concerns related to tax
      </p>
      {/* a */}
      <p
        className={styles.ques_heading}
        style={{ marginTop: hide ? "-1rem" : "2rem", marginBottom: "-1rem" }}
      >
        a. Approach to Stakeholder Engagement and Management of Stakeholder
        Concerns Related to Tax:
      </p>
      {/* i, ii, iii */}
      {questionData.map((el) => (
        <Box sx={{ mt: 0 }}>
          <Box
            sx={{
              display: "flex",
              marginLeft: "1rem",
              gap: 0.5,
              mt: hide ? "-1rem" : "1rem",
            }}
          >
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          <Box
            sx={{
              ml:4
            }}
          >
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI207_3;
